import React, { useEffect, useState } from 'react';
import { App, Button, Col, Drawer, Pagination, Row, Skeleton } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import { useHttp } from '../../Hooks/Http.hook';
import Filter from '../../Components/UI/FilterFind/Filter';
// import Price from '../../Components/UI/Filter/Price/Price';
import useWindowDimensions from '../../Hooks/WindowDimensions';
import { ReactComponent as FilterIcon } from '../../Icons/Filter.svg';
import cl from './search.module.css';
import Card from '../../Components/Card';
// import CheckValue from '../../Components/UI/Filter/CheckValue/CheckValue';

const SearchPage = () => {
    const [search] = useSearchParams();
    const { request } = useHttp(false);
    const { notification } = App.useApp();
    const [isLoading, setIsLoading] = useState(false);
    const [totalItems, setTotalItems] = useState(0);
    const [isEmpty, setIsEmpty] = useState(false);
    const [isOpenedDrawer, setIsOpenedDrawer] = useState(false);
    const [isLoadingInit, setIsLoadingInit] = useState(false);
    const navigate = useNavigate();
    const { width } = useWindowDimensions();
    const [currentPage, setCurrentPage] = useState(1);
    const [data, setData] = useState({});
    const perPage = 12;
    const city = useSelector((state) => state.city).items ?? {};
    useEffect(() => {
        const getData = () => {
            setIsEmpty(false);
            setIsLoading(true);
            if (!data.filter) {
                setIsLoadingInit(true);
            }
            request(
                `/api/search/${
                    city?.city ?? 0
                }?${search.toString()}&perPage=${perPage}`,
                'GET'
            )
                .then((res) => {
                    setIsLoading(false);
                    if (res?.error) {
                        notification.error({ message: res.error.message });
                    } else if (res?.data) {
                        setIsEmpty(res?.data?.products?.length === 0);
                        setData(res.data);
                        setTotalItems(res.data?.totalItems ?? 0);
                    }
                    setIsLoadingInit(false);
                })
                .catch(() => {
                    setIsLoadingInit(false);
                    setIsLoading(false);
                    notification.error({
                        message:
                            'Ошибка сервера. Попробуйте перезагрузить страницу.',
                    });
                });
        };
        window.scrollTo(0, 0);
        setCurrentPage(search.get('page') ? +search.get('page') : 1);
        getData();
    }, [search]);
    const clearPage = (searchStr) => {
        const arraySearch = searchStr.split('&');
        const result = [];
        arraySearch.forEach((item) => {
            if (item.split('=')[0] !== 'page') {
                result.push(item);
            }
        });
        return result.join('&');
    };
    const changePage = (page) => {
        setCurrentPage(page);
        const searchStr = clearPage(search.toString());
        navigate(`/search?${searchStr}&page=${page}`);
    };
    return (
        <div className="main-page">
            <Helmet>
                <title>Поиск</title>
            </Helmet>
            {isEmpty ? (
                <div className="main-page">
                    <h4 style={{ textAlign: 'center' }}>Ничего не найдено</h4>
                    <Button type="link" onClick={() => navigate('/')}>
                        На главную
                    </Button>
                </div>
            ) : (
                <section className={cl.container}>
                    {/* <Col style={ {width: '100%', height: 50 }}>
            <Breadcrumb items={breadcrumbs} />
        </Col> */}

                    <div
                        className={`${cl.productsContainer} ${cl.subCategories}`}
                    >
                        {/* eslint-disable-next-line no-nested-ternary */}
                        {data?.filter ? (
                            <Row style={{ width: '100%' }}>
                                {data?.filter[0]?.bucket.map((item) => (
                                    <Col
                                        onClick={() => {
                                            navigate(
                                                `/search/?${clearPage(
                                                    search.toString()
                                                )}&category=${item.key}`
                                            );
                                        }}
                                        key={item.key}
                                        to={`/categories/${item.key}`}
                                        className={cl.subCategoryItem}
                                    >
                                        <img
                                            src={item.photo ?? ''}
                                            alt=""
                                            className={cl.subCategoryItemImg}
                                        />
                                        <span
                                            className={cl.subCategoryItemText}
                                        >
                                            {item.name}({item.doc_count})
                                        </span>
                                    </Col>
                                ))}
                            </Row>
                        ) : isLoading ? (
                            <>
                                {[1, 2, 3, 4, 5, 6].map((skeletItem) => (
                                    <Skeleton.Button
                                        key={skeletItem}
                                        style={{
                                            margin: 10,
                                            width: 150,
                                            height: 120,
                                            borderRadius: 15,
                                        }}
                                        shape="square"
                                        active
                                    />
                                ))}
                            </>
                        ) : null}
                    </div>

                    <div className={cl.productsContainer}>
                        <h3 className={cl.title}>Товары</h3>

                        {width > 992 && (
                            // eslint-disable-next-line
                            <>
                                {isLoadingInit ? (
                                    <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                                        <Skeleton.Button
                                            style={{ height: 500 }}
                                            block
                                            shape="square"
                                            active
                                        />
                                    </Col>
                                ) : (
                                    // eslint-disable-next-line
                                    <>
                                        {data?.filter && (
                                            <Filter data={data?.filter} />
                                        )}
                                    </>
                                )}
                            </>
                        )}

                        <Drawer
                            width="100%"
                            placement="right"
                            closeIcon={
                                <LeftOutlined
                                    style={{ color: 'var(--primary-yellow)' }}
                                />
                            }
                            open={isOpenedDrawer}
                            onClose={() => setIsOpenedDrawer(false)}
                        >
                            <Filter data={data?.filter} />
                        </Drawer>

                        <Col xs={24} sm={24} md={24} lg={17} xl={17}>
                            <Row
                                style={{
                                    alignItems: 'center',
                                    // margin: '20px 0',
                                }}
                                align="middle"
                            >
                                <Col
                                    style={{
                                        textAlign: 'center',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'left',
                                    }}
                                    xs={24}
                                    sm={24}
                                    md={6}
                                    lg={6}
                                    xl={6}
                                >
                                    {width <= 992 && (
                                        <Button
                                            ghost
                                            onClick={() =>
                                                setIsOpenedDrawer(true)
                                            }
                                            className={cl.filterIcon}
                                        >
                                            <FilterIcon />
                                        </Button>
                                    )}
                                </Col>
                            </Row>

                            <Row className={cl.products}>
                                {/* eslint-disable-next-line no-nested-ternary */}
                                {data?.products
                                    ? data?.products.map((item) => (
                                          <Card
                                              key={item.general.id}
                                              id={item.general.id}
                                              title={item.general.name}
                                              article={item.general.number}
                                              media={item.media}
                                              price={[
                                                  item.price.naturalPrice,
                                                  item.price.juridicalPrice,
                                              ]}
                                              unit={item.general.unit}
                                              style={{ margin: 0 }}
                                          />
                                      ))
                                    : isLoading
                                      ? [1, 2, 3, 4, 5, 6, 7, 8].map(
                                            (skeletItem) => (
                                                <Skeleton.Button
                                                    key={skeletItem}
                                                    style={{
                                                        margin: 10,
                                                        width: 275,
                                                        height: 450,
                                                        borderRadius: 10,
                                                    }}
                                                    size="large"
                                                    shape="square"
                                                    active
                                                />
                                            )
                                        )
                                      : null}
                            </Row>
                            {totalItems > perPage && (
                                <Pagination
                                    pageSize={perPage}
                                    current={currentPage}
                                    total={totalItems}
                                    showSizeChanger={false}
                                    defaultCurrent={1}
                                    onChange={changePage}
                                />
                            )}
                        </Col>
                    </div>
                </section>
            )}
        </div>
    );
};

export default SearchPage;
